import { ApiClient } from '../../ApiClient';
import { AggregatedWeeklyForecastMapper, ForecastMapper, ForecastRunMapper } from '../mappers/ForecastMapper';
import { ForecastDTO } from '../dto/ForecastDTO';
import { Forecast, ForecastSourceType } from '@domain/forecast/models/Forecast';
import { WeeklyForecast } from '@domain/forecast/models/WeeklyForecast';
import { WeeklyForecastDTO } from '../dto/WeeklyForecastDTO';
import { ForecastRun } from '@domain/forecast/models/ForecastRun';
import { ForecastRunDTO } from '../dto/ForecastRunDTO';

export class ForecastDataSource {
  constructor(private api: ApiClient) { }

  async getLatestForecast(sourceType: ForecastSourceType, source?: string, connector?: string): Promise<Forecast> {
    try {
      const params = {
        sourceType,
        source,
        connector,
      };
      const response = await this.api.get<ForecastDTO>('/forecasts/latest', { params });
      return ForecastMapper.toModel(response.data);
    } catch (error) {
      throw new Error('Failed to fetch latest forecast');
    }
  }

  async getAggregatedForecast(): Promise<Omit<WeeklyForecast, 'forecastId'>[]> {
    try {
      const response = await this.api.get<WeeklyForecastDTO[]>('/forecasts/aggregated');
      return response.data.map(AggregatedWeeklyForecastMapper.toModel);
    } catch (error) {
      throw new Error('Failed to fetch aggregated forecast');
    }
  }

  async runProductForecast(product_id: string): Promise<ForecastRun> {
    try {
      const response = await this.api.post<ForecastRunDTO>('/forecasts/run/product', { product_id });
      return ForecastRunMapper.toModel(response.data);
    } catch (error) {
      throw new Error('Failed to run product forecast');
    }
  }

    async getProductRuns(product_id: string): Promise<ForecastRun[]> {
    try {
      const response = await this.api.get<ForecastRunDTO[]>(`/forecasts/run/product/${product_id}`);
      return response.data.map(ForecastRunMapper.toModel);
    } catch (error) {
      throw new Error('Failed to poll run status');
    }
  }
}

